import styled from "styled-components";

/* Section wrapper */
export const Section = styled.section`
  padding: 20px 20px;
  background-color: #1a1a1a; /* slightly lighter dark for contrast */
  border-top: 2px solid #0ff;
  border-bottom: 2px solid #0ff;
  text-align: center;
`;

/* Heading */
export const Heading = styled.h5`
  font-size: 1rem;
  color: #0ff;
  margin-bottom: 30px;
  font-weight: bold;
  letter-spacing: 2px;
`;

/* Scrollable container */
export const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 25px;
  padding: 20px 0;
  scroll-behavior: smooth;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #0ff;
    border-radius: 10px;
    box-shadow: 0 0 5px #0ff;
  }
  &::-webkit-scrollbar-track {
    background: #111;
  }
`;

/* Individual card */
export const ToolCard = styled.div`
  background: linear-gradient(145deg, #111, #222);
  border-radius: 20px;
  min-width: 220px;
  padding: 10px;
  text-align: center;
  box-shadow: 0 0 15px rgba(0,255,255,0.1);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 0 25px #0ff, 0 0 50px #0ff50;
    transform: translateY(-5px) rotate(-1deg);
  }

  @media (max-width: 480px) {
    min-width: 160px;
    padding: 15px;
  }
`;

/* Tool icon */
export const ToolIcon = styled.img`
  width: 60px;
  height: 60px;
  margin-bottom: 5px;
`;

/* Tool title */
export const ToolTitle = styled.h5`
  font-size: 1rem;
  margin-bottom: 10px;
  color: #0ff;
`;

/* Tool description */
export const ToolDesc = styled.p`
  font-size: 0.9rem;
  color: #aaa;
`;
